import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

const ButtonGroupRow = ({ stackAtSize, buttonAlignment, children, className, ...props }) => {
  const classes = classNames(
    "button-group__row",
    {
      [`button-group__row--${stackAtSize}-stacked`]: stackAtSize,
      "button-group__row--space-between": buttonAlignment === "space-between",
      "button-group__row--center": buttonAlignment === "center",
      "button-group__row--space-evenly": buttonAlignment === "space-evenly",
    },
    className
  );

  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
};

ButtonGroupRow.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  stackAtSize: PropTypes.string,
  className: PropTypes.string,
  buttonAlignment: PropTypes.oneOf(["space-between", "center", "space-evenly"]),
};

export default ButtonGroupRow;
